<template>
    <DefaultLayout :isRatesTable="true">
        <ratesTableContainer></ratesTableContainer>
    </DefaultLayout>
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
}
</script>
